import classNames from 'classnames';
import React from 'react';
import { LinkProps, Link as RouterIcon } from 'react-router-dom';
import styles from './Link.module.scss';

export const Link = ({ className, ...props }: LinkProps) => <RouterIcon className={classNames(styles.link, className)} {...props} />;
